import { sessionLocalStore } from '../../utils/sessionLocalStore'

const onLogoutUser = (history) => {

    sessionLocalStore.clear();
    history.push('/')
}

export default onLogoutUser;